function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { motion } from 'framer-motion';
import withStyles from 'isomorphic-style-loader/withStyles';
import isObjectLike from 'lodash/isObjectLike';
import isFunction from 'lodash/isFunction';
import { FormattedMessage } from 'react-intl';
import ChevronRightIcon from 'svg/chevron-right.svg';
import styles from './CollapsibleSection.pcss';
var _React_PureComponent;
class CollapsibleSection extends (_React_PureComponent = React.PureComponent) {
    onSwitch(evt) {
        evt.preventDefault();
        this.setState((state)=>({
                isOpening: !state.isOpening
            }));
    }
    onAnimationStart() {
        const { isOpen, isOpening } = this.state;
        if (isOpening && !isOpen) {
            this.setState({
                isOpen: true
            });
        } else if (!isOpening && isOpen) {
            this.setState({
                overflow: 'hidden'
            });
        }
    }
    onAnimationComplete() {
        const { isOpen, isOpening } = this.state;
        if (!isOpening && isOpen) {
            this.setState({
                isOpen: false
            });
        } else if (isOpening && isOpen) {
            this.setState({
                overflow: 'visible'
            });
        }
    }
    renderHeaderText() {
        if (isFunction(this.props.headerMessage)) return this.props.headerMessage();
        return isObjectLike(this.props.headerMessage) ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, this.props.headerMessage)) : this.props.headerMessage;
    }
    renderSwitchIndicator() {
        return /*#__PURE__*/ _jsx("div", {
            className: cn(styles.section__header__switchIndicator, {
                [styles['section__header__switchIndicator--expanded']]: this.state.isOpening
            }),
            children: /*#__PURE__*/ _jsx(ChevronRightIcon, {
                className: styles.section__header__switchIndicator__icon
            })
        });
    }
    render() {
        const { isOpen, isOpening, overflow } = this.state;
        return /*#__PURE__*/ _jsxs("section", {
            className: cn(this.props.className, styles.section, {
                [styles['section--open']]: isOpen
            }),
            children: [
                /*#__PURE__*/ _jsx("a", {
                    className: styles.section__switch,
                    onClick: (evt)=>this.onSwitch(evt),
                    children: /*#__PURE__*/ _jsxs("header", {
                        className: styles.section__header,
                        children: [
                            /*#__PURE__*/ _jsx("h5", {
                                className: cn(styles.section__header__text, 'text--h5'),
                                children: this.renderHeaderText()
                            }),
                            this.renderSwitchIndicator()
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(motion.div, {
                    initial: {
                        height: 0
                    },
                    animate: {
                        height: isOpening ? 'auto' : 0
                    },
                    transition: {
                        ease: 'easeOut',
                        duration: 0.3
                    },
                    className: styles.section__contentContainer,
                    style: {
                        overflow
                    },
                    onAnimationStart: ()=>this.onAnimationStart(),
                    onAnimationComplete: ()=>this.onAnimationComplete(),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "section mt-0",
                        children: this.props.children
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isOpen: false,
            isOpening: false,
            overflow: 'hidden'
        };
    }
}
_define_property(CollapsibleSection, "propTypes", {
    headerMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.func
    ]),
    children: PropTypes.node.isRequired,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ])
});
_define_property(CollapsibleSection, "defaultProps", {
    className: ''
});
export default withStyles(styles)(CollapsibleSection);
